import { component } from "picoapp";
import getProductJson from "../lib/getProductJson.js";
import $ from "jquery";
import { getQueryStringParameter, setQueryStringParameter } from "../lib/utils";
import { isUK, isUSA } from "../lib/customerLocation";
import {
  TablescapeContext,
  TablescapeEvent,
} from "../../tablescape/utilities/tablescapeContext";
import { debounce } from "../../tablescape/utilities";

export default component((node, context) => {
  const initialVariantId = node.dataset.initialVariantId;
  const productId = node.dataset.productId;
  const riseHeadlessIntegrationEnabled =
    node.dataset.riseHeadlessIntegrationEnabled === "true";

  // cache
  getProductJson();

  if (!getQueryStringParameter("variant")) {
    setQueryStringParameter("variant", initialVariantId);
  }

  window.addEventListener("variant-selected:id", async (event) => {
    const product = await getProductJson();
    const { variant: variantId } = event.detail;
    const variant = product.variants.find(
      (v) => parseInt(v.id) === parseInt(variantId)
    );
    if (!variant) return;

    const { currentVariant } = context.getState();
    if (currentVariant.id === parseInt(variantId)) {
      return false;
    }
    context.hydrate({ currentVariant: variant });
    setQueryStringParameter("variant", variant.id);
    if (variant.available) {
      $(".js-add-to-cart").show();
    } else {
      $(".js-add-to-cart").hide();
    }
    node.dataset.productVariantMsrp = variant.compare_at_price ?? variant.price;

    if (isUK() || isUSA()) {
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
      window.KlarnaOnsiteService.push({ eventName: "refresh-placements" });
    }
  });

  // Rise headless integration
  if (riseHeadlessIntegrationEnabled) {
    const addToCart = (lineItemProps) => {
      const {
        // eslint-disable-next-line camelcase
        gift: { _gift_id, message, email, name },
      } = lineItemProps;
      const { currentVariant } = context.getState();
      try {
        TablescapeContext.emit(TablescapeEvent.TOGGLE_CART, {
          ui: {
            cartDrawerOpen: true,
            cartDrawerUserToggled: false,
            giftNoteDrawerOpen: false,
            productVariantDrawerOpen: false,
          },
        });

        TablescapeContext.emit(TablescapeEvent.ADD_TO_CART, {
          cart: {
            lines: [
              {
                attributes: [
                  {
                    key: "_msrp",
                    value: String(node.dataset.productVariantMsrp),
                  },
                  {
                    key: "_gift_id",
                    // eslint-disable-next-line camelcase
                    value: String(_gift_id),
                  },
                  {
                    key: "name",
                    value: String(name),
                  },
                  {
                    key: "message",
                    value: String(message),
                  },
                  {
                    key: "email",
                    value: String(email),
                  },
                ],
                id: currentVariant.id ?? initialVariantId,
                quantity: 1,
              },
            ],
          },
        });
      } catch (error) {
        console.error(error);
      }
    };

    window.Rise = {
      full_product: { available: true },
      is_floating_cart_theme: true,
      is_product_page: true,
      product: { id: productId },
      using_add_to_cart_flow: false,
      onGiftAdded: debounce((lineItemProps) => addToCart(lineItemProps), 250),
    };
  }
});
